import { Injectable } from "@angular/core";
import { Modal, ModalService } from "@core-services/modal.service";
import { AntiPhishingForceModalComponent } from "../components/anti-phishing-force-modal/anti-phishing-force-modal.component";
import { SecurityAntiPhishingModalComponent } from "../components/anti-phishing-modal/anti-phishing-modal.component";
import { AntiPhishingBlockType } from "@modules/shared/modals/anti-phishing-code-modal/interfaces";
import { Helper } from "@helpers/functions";

@Injectable({
	providedIn: "root"
})
export class AntiPhishingCodeModalService {
	public antiPhishingForceModal: Modal;
	public antiPhishingSetupModal: Modal;
	private APCforceModalOptions = {
		preventBackdropDismiss: true,
		preventEscDismiss: true
	};
	public currentAntiPhishingCode: string = "";
	public isAntiPhishingSetupInProgress: boolean = false;

	public constructor(private readonly modalService: ModalService) {}

	public openAntiPhishingForceModal(apcBlockType: AntiPhishingBlockType): void {
		this.modalService.popAll();
		this.antiPhishingForceModal = this.modalService
			.create(
				AntiPhishingForceModalComponent,
				{
					data: { apcBlockType }
				},
				this.APCforceModalOptions
			)
			.present();
	}

	public openAntiPhishingSetupModal(currentAntiPhishingCode: string = "", preventDismiss: boolean = false): void {
		this.isAntiPhishingSetupInProgress = true;
		const data = {
			currentAntiPhishingCode: currentAntiPhishingCode,
			preventDismiss
		};
		const modalOptions = {
			preventBackdropDismiss: preventDismiss,
			preventEscDismiss: preventDismiss
		};
		this.antiPhishingSetupModal = this.modalService
			.create(SecurityAntiPhishingModalComponent, { data }, modalOptions)
			.present();

		this.antiPhishingSetupModal.onDismiss.subscribe(() => {
			this.isAntiPhishingSetupInProgress = false;
		});
	}

	public skipApcSetup(): void {
		const today = new Date().toString();
		Helper.setCookie("anti_phishing_code_skiped", today, false);
	}
}
